import Styled from "styled-components";

/* const LinesWrapper = styled(Row)`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	width: 100%;
	padding: 8px 32px 0;
`; */

const LinesWrapper = Styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	margin-right: 10px;
	margin-left: 10px;
	/* justify-content: center; */
	width: 100%;
`;

const WrapperEmpty = Styled.div`
	flex: 0 1 auto;
	flex-grow: 1;
`;

const FolderName = Styled.h3`
	color: #096dd9;
	margin: 0;
	text-align: left;
	width: 100%;
	padding-left: 24px;
	margin-bottom: -8px;
`;

const BackButton = Styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 5px 16px;
	height: 32px;
	background: #ffffff;
	border: 1px solid #d9d9d9;
	box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);
	border-radius: 2px;
	&:hover {
		cursor: pointer;
		border: 1px solid #9ac2ff;
	}
`;

const buttonConfig = {
	primary: {
		background: "#7E2F8A",
		border: "none",
		color: "#fff",
	},
	backgroundless: {
		background: "transparent",
		border: "1px solid #D9D9D9",
	},
	disabled: {
		background: "#D9D9D9",
		border: "none",
		color: "#fff",
	},
	cancelReservation: {
		background: "transparent",
		border: "none",
		color: "#A157B0",
	},
	genericModalPrimary: {
		background: "#FF4D4F",
		border: "none",
		color: "#fff",
		width: "100%",
	},
	backgroundWhite: {
		background: "#fff",
		border: "none",
		color: "#000 !important",
		width: "100%",
	},
};

const ButtonStyled = Styled.button`
	font-family: "Montserrat", sans-serif;
	padding: 8px;
	background: ${(props) => {
		return props.disabled
			? buttonConfig["disabled"].background
			: buttonConfig[props.typeForStyled].background;
	}};
	border: ${(props) =>
		props.disabled
			? buttonConfig["disabled"].border
			: buttonConfig[props.typeForStyled].border};
	color: ${(props) =>
		props.disabled
			? buttonConfig["disabled"].color
			: buttonConfig[props.typeForStyled].color};
	border-radius: 4px;
	min-width: 100px;
	font-weight: 500;
	margin-right: 12px;
	max-height: 38px;
	width: ${(props) => props.size && props.size};
	:hover,
	:active {
		cursor: pointer;
	}
`;

export { LinesWrapper, WrapperEmpty, FolderName, BackButton, ButtonStyled };
